// 系统管理权限
export const SYSTEM_PERMISSIONS = {
  // 客户账号管理
  CLIENT_CREATE: 'system:client:create',
  CLIENT_READ: 'system:client:read',
  CLIENT_UPDATE: 'system:client:update',
  CLIENT_DELETE: 'system:client:delete',
  CLIENT_TOGGLE: 'system:client:toggle',
  
  // 系统配置管理
  CONFIG_READ: 'system:config:read',
  CONFIG_UPDATE: 'system:config:update',
  
  // 全局数据监控
  MONITOR_READ: 'system:monitor:read',
  USAGE_READ: 'system:usage:read',
  
  // 用户套餐管理
  PACKAGE_CREATE: 'system:package:create',
  PACKAGE_READ: 'system:package:read',
  PACKAGE_UPDATE: 'system:package:update',
  PACKAGE_DELETE: 'system:package:delete',
  
  // 系统安全管理
  SECURITY_READ: 'system:security:read',
  SECURITY_UPDATE: 'system:security:update',
  
  // 系统管理所有权限
  ALL: 'system:*',
} as const;

// 客户管理权限
export const CLIENT_PERMISSIONS = {
  // 子账号管理
  SUB_ACCOUNT_CREATE: 'client:sub-account:create',
  SUB_ACCOUNT_READ: 'client:sub-account:read',
  SUB_ACCOUNT_UPDATE: 'client:sub-account:update',
  SUB_ACCOUNT_DELETE: 'client:sub-account:delete',
  SUB_ACCOUNT_TOGGLE: 'client:sub-account:toggle',
  
  // 客户资料管理
  PROFILE_READ: 'client:profile:read',
  PROFILE_UPDATE: 'client:profile:update',
  
  // 客户配置管理
  CONFIG_READ: 'client:config:read',
  CONFIG_UPDATE: 'client:config:update',
  
  // 客户管理所有权限
  ALL: 'client:*',
} as const;

// 链接管理权限
export const LINK_PERMISSIONS = {
  CREATE: 'link:create',
  READ: 'link:read',
  UPDATE: 'link:update',
  DELETE: 'link:delete',
  TOGGLE: 'link:toggle',
} as const;

// 域名管理权限
export const DOMAIN_PERMISSIONS = {
  CREATE: 'domain:create',
  READ: 'domain:read',
  UPDATE: 'domain:update',
  DELETE: 'domain:delete',
  TOGGLE: 'domain:toggle',
} as const;

// 拦截规则管理权限
export const RULE_PERMISSIONS = {
  CREATE: 'rule:create',
  READ: 'rule:read',
  UPDATE: 'rule:update',
  DELETE: 'rule:delete',
} as const;

// 访客记录管理权限
export const VISITOR_PERMISSIONS = {
  READ: 'visitor:read',
  EXPORT: 'visitor:export',
} as const;

// 统计数据管理权限
export const STATS_PERMISSIONS = {
  READ: 'stats:read',
  EXPORT: 'stats:export',
} as const;

// 计费管理权限
export const BILLING_PERMISSIONS = {
  PLAN_CREATE: 'billing:plan:create',
  PLAN_READ: 'billing:plan:read',
  PLAN_UPDATE: 'billing:plan:update',
  PLAN_DELETE: 'billing:plan:delete',
  PLAN_TOGGLE: 'billing:plan:toggle',
  SUBSCRIPTION_READ: 'billing:subscription:read',
  SUBSCRIPTION_UPDATE: 'billing:subscription:update',
} as const;

// 角色权限管理权限
export const ROLE_PERMISSIONS = {
  CREATE: 'role:create',
  READ: 'role:read',
  UPDATE: 'role:update',
  DELETE: 'role:delete',
  ASSIGN: 'role:assign',
} as const;

// 超级管理员权限
export const SUPER_ADMIN_PERMISSION = '*:*';

// 权限组
export const PERMISSION_GROUPS = {
  SYSTEM_MANAGEMENT: Object.values(SYSTEM_PERMISSIONS),
  CLIENT_MANAGEMENT: Object.values(CLIENT_PERMISSIONS),
  LINK_MANAGEMENT: Object.values(LINK_PERMISSIONS),
  DOMAIN_MANAGEMENT: Object.values(DOMAIN_PERMISSIONS),
  RULE_MANAGEMENT: Object.values(RULE_PERMISSIONS),
  VISITOR_MANAGEMENT: Object.values(VISITOR_PERMISSIONS),
  STATS_MANAGEMENT: Object.values(STATS_PERMISSIONS),
  ROLE_MANAGEMENT: Object.values(ROLE_PERMISSIONS),
  BILLING_MANAGEMENT: Object.values(BILLING_PERMISSIONS),
} as const;